import { useMediaQuery } from "@chakra-ui/react";

function useMediaQ() {
  const [isLandscape] = useMediaQuery("(orientation: landscape)");
  const [isPortrait] = useMediaQuery("(orientation: portrait)");

  const [sm] = useMediaQuery("(min-width: 900px)");
  const [sm_h] = useMediaQuery("(min-height: 500px)");
  const [md] = useMediaQuery("(min-width: 800px)");
  const [md_900] = useMediaQuery("(min-width: 900px)");
  const [lg_1060] = useMediaQuery("(min-width: 1060px)");
  const [lg] = useMediaQuery("(min-width: 1000px)");
  const [xl] = useMediaQuery("(min-width: 1200px)");

  const isMobileView = (!sm && !md && !lg && !xl) || isLandscape;

  return { sm, md, lg, xl, sm_h, md_900, lg_1060, isLandscape, isPortrait, isMobileView };

  
}

export default useMediaQ;
